module.exports = {"231004001":"向阳街道","231004002":"黄花街道","231004003":"铁北街道","231004004":"新华街道","231004005":"大庆街道","231004006":"兴平街道","231004007":"北山街道","231004100":"三道关镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/231004.json
// module id = 717
// module chunks = 0